enum CategoryResourceType {
  SESSION = 0,
  EXPERT = 1,
  ARTICLE = 2,
}

export default CategoryResourceType;
